import { Controller } from "@hotwired/stimulus";
import { adminCable } from "src/admin_cable";
import DispatchApiClient from "src/admin/dispatch/dispatch_api_client";

interface DispatchDashCheckInData {
  area: {
    id: number;
    name: string;
  },
  admin: {
    id: number;
    email: string;
  },
  status: {
    path: string;
    title: string;
    version: string;
    dashboardChannel: {
      lastConnectedAt?: number;
      lastDisconnectedAt?: number;
      lastReceivedDataAt?: number;
    };
    trackingChannel: {
      lastConnectedAt?: number;
      lastDisconnectedAt?: number;
      lastReceivedDataAt?: number;
    };
  }
}

export default class DispatchDebugController extends Controller {
  static targets = ["output"];

  declare outputTarget: HTMLTableElement;

  areaId: number = 0;
  apiClient?: DispatchApiClient;
  subscription?: ActionCable.Subscription;

  connect() {
    this.areaId = parseInt(this.data.get("area-id") ?? '');
    this.subscription = adminCable().subscriptions.create({ channel: "DebuggingChannel", area_id: this.areaId }, {
      connected: () => {
        this.requestCheckIn();
      },
      received: (data: DispatchDashCheckInData) => {
        if (data.area.id != this.areaId) return;
        const row = document.createElement("tr");
        this.appendLinkCell(row, `/admin/admins/${data.admin.id}/edit`, data.admin.email);
        this.appendLinkCell(row, data.status.path, data.status.title);
        this.appendTextCell(row, data.status.version);
        this.appendTextCell(row, this.timestampString(data.status.dashboardChannel.lastDisconnectedAt));
        this.appendTextCell(row, this.timestampString(data.status.dashboardChannel.lastConnectedAt));
        this.appendTextCell(row, this.timestampString(data.status.dashboardChannel.lastReceivedDataAt));
        this.appendTextCell(row, this.timestampString(data.status.trackingChannel.lastDisconnectedAt));
        this.appendTextCell(row, this.timestampString(data.status.trackingChannel.lastConnectedAt));
        this.appendTextCell(row, this.timestampString(data.status.trackingChannel.lastReceivedDataAt));
        this.outputTarget?.appendChild(row);
      },
    });
  }

  disconnect() {
    this.subscription?.unsubscribe();
    this.subscription = undefined;
  }

  requestCheckIn() {
    this.subscription?.perform("request_check_in", { area_id: this.areaId })
  }

  requestCapture() {
    this.subscription?.perform("request_capture", { area_id: this.areaId })
  }

  appendTextCell(row: HTMLTableRowElement, content: string | number | undefined): void {
    const cell = row.insertCell();
    cell.textContent = content == undefined ? '' : content.toString();
  }

  appendLinkCell(row: HTMLTableRowElement, href: string, label: string) {
    const cell = row.insertCell();
    const link = document.createElement("a");
    link.href = href;
    link.textContent = label;
    cell.appendChild(link);
  }

  timestampString(timestamp?: number): string {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleString("en-NZ", { hour: "2-digit", minute: "2-digit", year: 'numeric', month: 'short', day: 'numeric' });
  }
}
